export enum Severity {
  Error,
  Warning
}
